/**
 * Industry Showcase — sanitized demo data for 4 Filipino business types.
 *
 * Pure static content. No API calls. No real customer / staff / sales data.
 */
export const INDUSTRY_SHOWCASE = [
  {
    key: "sari-sari",
    label: "Sari-Sari Store",
    tagline: "Fast everyday selling with stocks and customer utang in one place.",
    pos: {
      heading: "Aling Nena's Store",
      menuTitle: "Daily picks",
      items: [
        { name: "Sardines 155g", price: 25 },
        { name: "Lucky Me Pancit", price: 15 },
        { name: "Coke 1.5L", price: 85 },
        { name: "Palmolive Sachet", price: 10 },
        { name: "Rice 1kg", price: 60 },
        { name: "Biscuits", price: 10 },
        { name: "Milo Sachet", price: 12 },
        { name: "Nescafé 3-in-1", price: 10 },
        { name: "Candy Mix", price: 5 },
      ],
      cart: [
        { name: "Sardines 155g", qty: 2, price: 25 },
        { name: "Rice 1kg", qty: 1, price: 60 },
        { name: "Palmolive Sachet", qty: 3, price: 10 },
      ],
      payments: ["Cash", "GCash", "Utang"],
      activePayment: "Utang",
    },
    panel: {
      heading: "Store today",
      subheading: "Mon · 5:12 PM",
      kpis: [
        { label: "Today's Sales", value: "₱2,450" },
        { label: "Utang", value: "₱780" },
      ],
      lowStock: [
        { name: "Lucky Me Pancit", left: "4 pcs" },
        { name: "Palmolive Sachet", left: "6 pcs" },
        { name: "Coke 1.5L", left: "3 btls" },
      ],
      fastMoving: ["Sardines", "Rice 1kg", "Milo Sachet"],
    },
    accent: "from-amber-500/20 via-amber-500/5 to-transparent",
    chipBg: "bg-amber-500/10 text-amber-700 dark:text-amber-300",
  },
  {
    key: "coffee-shop",
    label: "Coffee Shop",
    tagline: "Take orders quickly while keeping an eye on ingredients and supplies.",
    pos: {
      heading: "Brewline Café",
      menuTitle: "Drinks",
      items: [
        { name: "Americano", price: 90 },
        { name: "Iced Latte", price: 130 },
        { name: "Cappuccino", price: 120 },
        { name: "Matcha Latte", price: 150 },
        { name: "Spanish Latte", price: 140 },
        { name: "Pandan Pastry", price: 65 },
        { name: "Butter Croissant", price: 80 },
        { name: "Choco Chip", price: 55 },
        { name: "Bottled Water", price: 25 },
      ],
      cart: [
        { name: "Iced Latte", qty: 2, price: 130 },
        { name: "Butter Croissant", qty: 1, price: 80 },
      ],
      payments: ["Cash", "GCash", "Card"],
      activePayment: "GCash",
    },
    panel: {
      heading: "Ingredients",
      subheading: "Tue · 10:04 AM",
      kpis: [
        { label: "Cups served", value: "128" },
        { label: "Low stock", value: "3 items" },
      ],
      lowStock: [
        { name: "Fresh Milk 1L", left: "2 ctns" },
        { name: "Espresso Beans", left: "1.2 kg" },
        { name: "Vanilla Syrup", left: "250 ml" },
      ],
      fastMoving: ["Iced Latte", "Americano", "Spanish Latte"],
    },
    accent: "from-emerald-500/20 via-emerald-500/5 to-transparent",
    chipBg: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-300",
  },
  {
    key: "bigasan",
    label: "Bigasan",
    tagline: "Track rice sales and remaining stock from sacks down to practical selling quantities.",
    pos: {
      heading: "Masagana Bigasan",
      menuTitle: "Rice varieties",
      items: [
        { name: "Dinorado · 1 kg", price: 68 },
        { name: "Dinorado · 5 kg", price: 325 },
        { name: "Dinorado · 25 kg", price: 1550 },
        { name: "Sinandomeng · 1 kg", price: 55 },
        { name: "Sinandomeng · 5 kg", price: 265 },
        { name: "Sinandomeng · 25 kg", price: 1275 },
        { name: "Well-Milled · 1 kg", price: 48 },
        { name: "Well-Milled · 5 kg", price: 230 },
        { name: "Well-Milled · 25 kg", price: 1125 },
      ],
      cart: [
        { name: "Dinorado · 5 kg", qty: 1, price: 325 },
        { name: "Sinandomeng · 1 kg", qty: 3, price: 55 },
      ],
      payments: ["Cash", "GCash"],
      activePayment: "Cash",
    },
    panel: {
      heading: "Rice on hand",
      subheading: "Wed · 7:22 AM",
      kpis: [
        { label: "Kilos sold today", value: "182" },
        { label: "Sacks left", value: "11" },
      ],
      lowStock: [
        { name: "Dinorado 25kg", left: "2 sacks" },
        { name: "Well-Milled 25kg", left: "1 sack" },
      ],
      fastMoving: ["Dinorado · 1 kg", "Sinandomeng · 5 kg", "Well-Milled · 1 kg"],
    },
    accent: "from-yellow-500/20 via-yellow-500/5 to-transparent",
    chipBg: "bg-yellow-500/10 text-yellow-800 dark:text-yellow-300",
  },
  {
    key: "restaurant",
    label: "Restaurant",
    tagline: "Handle fast order entry while monitoring menu items and inventory.",
    pos: {
      heading: "Hapag Kainan",
      menuTitle: "Menu",
      items: [
        { name: "Chicken Meal", price: 160 },
        { name: "Pork Sisig Meal", price: 180 },
        { name: "Beef Caldereta Meal", price: 220 },
        { name: "Extra Rice", price: 25 },
        { name: "Garlic Rice", price: 35 },
        { name: "Iced Tea", price: 45 },
        { name: "Softdrink", price: 40 },
        { name: "Egg Add-on", price: 20 },
        { name: "Fried Lumpia", price: 30 },
      ],
      cart: [
        { name: "Chicken Meal", qty: 2, price: 160 },
        { name: "Extra Rice", qty: 2, price: 25 },
        { name: "Iced Tea", qty: 2, price: 45 },
      ],
      payments: ["Cash", "GCash", "Card"],
      activePayment: "Cash",
    },
    panel: {
      heading: "Kitchen today",
      subheading: "Fri · 12:40 PM",
      kpis: [
        { label: "Orders today", value: "63" },
        { label: "Daily sales", value: "₱9,180" },
      ],
      lowStock: [
        { name: "Chicken Thigh", left: "4 kg" },
        { name: "Soy Sauce 1L", left: "2 btls" },
        { name: "Calamansi", left: "1.5 kg" },
      ],
      fastMoving: ["Chicken Meal", "Extra Rice", "Pork Sisig Meal"],
    },
    accent: "from-rose-500/20 via-rose-500/5 to-transparent",
    chipBg: "bg-rose-500/10 text-rose-700 dark:text-rose-300",
  },
];

export const SLIDE_COUNT = INDUSTRY_SHOWCASE.length;
